import { useState } from 'react';
import Lottie from 'lottie-react-web';
import loadingAnimation from './loading.json';

const FormSection = ({ generateResponse, isLoading, error }) => {
  const [question, setQuestion] = useState('');
  const [isLoadingResponse, setIsLoadingResponse] = useState(false);

  const handleSubmit = () => {
    const newQuestion = question.trim();
    if (newQuestion.length === 0 || isLoading || isLoadingResponse) {
      return;
    }
    setIsLoadingResponse(true);
    generateResponse(newQuestion, () => {
      setQuestion('');
      setIsLoadingResponse(false);
    });
  };

  return (
    <div className="form-section">
      {error && <p className="error">{error}</p>}
      {isLoadingResponse ? (
        <div className="loading-animation">
          <Lottie
            options={{
              animationData: loadingAnimation,
              loop: true,
            }}
            width={350}
            height={350}
          />
        </div>
      ) : (
        <textarea
          rows="5"
          className="form-control"
          placeholder="Тема"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />
      )}
      <button
        className={`btn ${isLoadingResponse ? 'btn-disabled' : ''}`}
        onClick={handleSubmit}
        disabled={isLoading || isLoadingResponse}
      >
        {isLoadingResponse ? 'ГЕНЕРИРУЮ ОТВЕТ' : 'ПОЛУЧИТЬ ОТВЕТ'}
      </button>
    </div>
  );
};

export default FormSection;